export const screenSizes = {
  screenXs: 480,
  screenSm: 769,
  screenMd: 922,
  screenLg: 1200,
};

export const endpoints = {
  eventSearch: '/api/acm/search/PerformEventSearch',
  articlesSearch: '/api/acm/search/PerformContentPageSearch',
  applyPromoCode: '/controller/Cart/ApplyPromoCode',
  removePromoCode: '/controller/Cart/RemovePromoCode',
  selectPerformance: '/controller/Cart/SelectPerformance',
  performEventSearch: '/api/acm/search/PerformEventSearch',
  performContentPageSearch: '/api/acm/search/PerformContentPageSearch',
  getFeaturedEvents: '/api/acm/events/GetFeaturedEvents',
  getUpcomingEvents: '/api/acm/events/GetUpcomingEvents',
  whatsOnToday: '/api/acm/events/WhatsOnToday',
  loginUser: '/controller/Account/LoginUser',
  saveGuestRegistrationInformation: '/controller/Account/SaveGuestRegistrationInformation',
  processDelivery: '/controller/Cart/ProcessDelivery',
  requestSeats: '/controller/Cart/RequestSeats',
  payForOrder: '/controller/Cart/PayForOrder',
  getFilters: '/api/acm/events/GetFilters',
  getFeaturedEventsForContent: '/api/acm/events/GetFeaturedEventsForContentPage',
  addDeliveryAddress: '/controller/Cart/AddDeliveryAddress',
  addDonation: '/controller/Cart/AddDonation',
  removeSeats: '/controller/Cart/RemoveSeats',
  removeDonation: '/controller/Cart/RemoveDonation',
  removeMembership: '/controller/Cart/RemoveMembership',
  removeCertificate: '/controller/Cart/RemoveCertificate',
  applyGiftCertificate: '/controller/Cart/ApplyGiftCertificate',
  unapplyCertificate: '/controller/Cart/UnApplyCertificate',
  addUpsellItemToCart: '/controller/Cart/AddUpsellItemToCart',
  saveRegistrationInformation: '/controller/Account/SaveRegistrationInformation',
  forgotUserPassword: '/controller/Account/ForgotUserPassword',
  userPreference: '/controller/Account/UserPreference',
  getStates: '/api/acm/referencedata/getstates',
  updateAccountInformation: '/controller/Account/UpdateAccountInformation',
  addMembershipToCart: '/controller/Account/AddMembershipToCart',
  changePassword: '/controller/Account/ChangeUserPassword',
  addGiftCertificate: '/controller/Cart/AddGiftCertificate',
  resetUserPassword: '/controller/Account/ResetUserPassword',
  updateAddressInformation: '/controller/Account/UpdateAddressInformation',
  deleteAddressInformation: '/controller/Account/DeleteAddress',
  makePrimaryAddress: '/controller/Account/MakePrimaryAddress',
};

export const appConstants = {
  apiBaseUrl: '/',
  siteBaseUrl: '/',
  accountMembershipUrl: '/my-account/membership',
  loginUrl: '/my-account/login',
  GenreOrderBy: [
    { key: '1', name: 'Date' },
    { key: '3', name: 'Title (A-Z)' },
    { key: '4', name: 'Title (Z-A)' },
  ],
  OrderBy: {
    FirstPerformanceDate: 1,
    Date: 2,
    Ascending: 3,
    Descending: 4,
  },
  TileType: {
    Event: 1,
    Performance: 2,
  },
  PageType: {
    EventCalendar: 1,
    GenreLanding: 2,
    WhatsOnToday: 3,
    WeThinkYouMightLike: 4,
    EventDetail: 5,
    Home: 6,
    Search: 7,
  },
  DateOption: {
    InTheNext30Days: 'In+the+next+30+days',
    AtAnyTime: 'At+any+time',
    Today: 'Today',
  },
  GenreFilterId: '',
  LabelType: {
    Default: 0,
    AllocationExhausted: 1,
    SellingFast: 2,
    MembersOnly: 3,
    Accessible: 4,
    PerformanceUnavailable: 5,
  },
  ErrorMessages: {
    InvalidCC: 'Invalid Credit Card Number',
    DonationCantBeAdded: 'A Donation cannot be added at this time',
    GiftCertificateCantBeAdded: 'Gift voucher cannot be added at this time',
  },
  DeliveryMethodType: {
    VenueCollection: -1,
    RegularPost: 1,
    ExpressPost: 3,
    RegisteredPost: 4,
    MobileTicket: 18,
    ETicket: 21,
    CompanionCard: 24,
  },
};
